<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
    </div>

    <el-form ref="form" :model="form" :label-width="labelWidth">
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <div class="btns">
      <el-button type="primary" @click="onSubmit">保 存</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FinanceBaseSalary",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'basepay',
      
      breadcrumb: [
        { name: "系统设置" },
        { name: "工资提成设置" },
      ],
      formCtrl: [
        // {
        //   label: "押运员工资",
        //   keyName: "maxescort",
        //   err: "请填写押运员工资",
        //   type: "number",
        //   unit: "元",
        // },
        // {
        //   label: "司机基本工资",
        //   keyName: "basedriver",
        //   err: "请填写司机基本工资",
        //   type: "number",
        //   unit: "元",
        // },
        // {
        //   label: "司机提成比例",
        //   keyName: "roydriver",
        //   err: "请填写司机提成",
        //   type: "number",
        //   unit: "%",
        //   tips: "在车队净利润当中提取，不填写默认没有提成",
        // },
        // {
        //   label: "司机提成初始毛利润",
        //   keyName: "roydriveramount",
        //   err: "请填写司机提成初始毛利润",
        //   type: "number",
        //   unit: "元",
        // },
        // {
        //   label: "车队长基本工资",
        //   keyName: "basefleet",
        //   err: "请填写车队长基本工资",
        //   type: "number",
        //   unit: "元",
        // },
        // {
        //   label: "车队长提成比例",
        //   keyName: "royfleet",
        //   err: "请填写车队长提成",
        //   type: "number",
        //   unit: "%",
        //   tips: "在车队净利润当中提取，不填写默认没有提成",
        // },
        // {
        //   label: "车队长提成初始毛利润",
        //   keyName: "royfleetamount",
        //   err: "请填写车队长提成初始毛利润",
        //   type: "number",
        //   unit: "元",
        // },
        {
          label: "里程工资提成单价",
          keyName: "unitprice",
          err: "请填写里程工资提成单价",
          type: "number",
          unit: "元/公里",
          //tips:"在车队净利润当中提取，不填写默认没有提成",
        },
      ],
    };
  },
  methods: {
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/index`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          this.detail = data
          this.formCtrl.map(v => {
            const key = v.keyName
            this.form[key] = this.detail[key];
          })
          this.$forceUpdate()
          // console.log({ ...this.detail })
          // console.log({ ...this.form })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSubmit() {
      console.log({ ...this.form });
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq() {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        // userid: this.user.id,
      }
      const object = this.form
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .tips {
      margin: 10px auto 0;
    }

    .el-input {
      width: 200px;
    }
  }

  // .el-textarea {
  //   width: 200px;
  // }
}

.btns {
  margin: 40px 0 60px 180px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;

  /deep/ .wxts {
    .b {
      width: 400px;
    }
  }
}
</style>
